const current = {
  namespaced: true,
  state: {
    tab: 'shirts',
  },
  mutations: {
    setTab (state, payload) {
      state.tab = payload
    }
  }
}
export default current
